import yaml from 'js-yaml'
export default yaml.load(`
- role: Speaker
  topic: "NEWLINE: Reverse auction reservation system"
  conference: "Engineering Talk, 25th March 2012"
  organization: "Chulalongkorn University Broadcasting Station (CU Radio)FM 101.5 MHz"
  link: "http://www.curadio.chula.ac.th/Program/eg/Program-Detail.php?id=167&rand=307129716"
  linkTitle: "Link to the talk (in Thai)"
`)


/** WEBPACK FOOTER **
 ** ../data/talks.js
 **/